import {Module} from 'vuex';
import {RootState} from '@/store';
import {login, logout, requestDemo} from '@/api';
import {setRefreshToken} from '@/utils';
import {DemoForm} from '@/models/LoginModel';

type LoginState = {
    loading: boolean;
    wrongLoginOrPassword: boolean;
};

const LoginModule: Module<LoginState, RootState> = {
    namespaced: true,
    state: {
        loading: false,
        wrongLoginOrPassword: false,
    },
    mutations: {
        setLoading: (state, bool) => (state.loading = bool),
        setWrongLoginOrPassword: (state, bool) => (state.wrongLoginOrPassword = bool),
    },
    actions: {
        login: ({commit, dispatch}, loginForm) => {
            return new Promise(async resolve => {
                commit('setLoading', true);
                try {
                    const {data} = await login(loginForm);
                    commit('setToken', data.Token, {root: true});
                    setRefreshToken(data.RefreshToken);
                    await dispatch('getStatus', undefined, {root: true});
                    commit('setAuthorized', true, {root: true});
                    resolve();
                } catch (e) {
                    if (e?.response.status === 404) commit('setWrongLoginOrPassword', true);
                    throw e;
                } finally {
                    commit('setLoading', false);
                }
            });
        },
        logout: async ({commit}) => {
            try {
                await logout();
                commit('setAuthorized', false, {root: true});
                commit('setStatus', null, {root: true});
                commit('setToken', null, {root: true});
                setRefreshToken(null);
            } catch (e) {
                console.log(e);
            }
        },
        requestDemo: ({commit}, form: DemoForm) => {
            return new Promise(async resolve => {
                commit('setLoading', true);
                try {
                    await requestDemo(form);
                    resolve();
                } finally {
                    commit('setLoading', false);
                }
            });
        },
    },
};

export default LoginModule;
